import React from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Classes from '../../common/Classes';
import TranslationService from '../../translations';
import StringFormatter from '../../common/StringFormatter';
import Tags from '../../common/dtmTags';
import { defaultOrganisationListingLogoUrl } from '../../../images/assets.json';
import ExhibitorDirectoryImage from '../ExhibitorDirectoryImage';
import Stand from './components/Stand';

class ExhibitorDirectoryGridView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  generateExhibitors() {
    const { exhibitors = [] } = this.props;
    return exhibitors.map(exhibitor => this.generateExhibitor(exhibitor));
  }

  generateExhibitor = (exhibitor) => {
    const {
      navigation, isRounded, context, hideStandInfo
    } = this.props;
    const translation = TranslationService.getTranslations(context.interfaceLocale);
    const linkURL = StringFormatter.format(navigation.exhibitorPublicDetailsUrlFormat, exhibitor.organisationGuid);
    const dataDtm = Tags.exhibitorDirectory.exhibitor;
    const exhibitorImageProps = {
      alt: exhibitor.name,
      src: exhibitor.logo,
      defaultLogoUrl: defaultOrganisationListingLogoUrl,
      isRounded,
      tag: Tags.exhibitorDirectory.gridView.exhibitor
    };

    const customClasses = `${Classes.exhibitorTile} ${Classes.enhancement}`;
    return (
      <Col xs={16} sm={6} md={4} className={customClasses} key={exhibitor.id}>
        <a
          href={linkURL}
          data-dtm={dataDtm}
        >
          <div>
            <ExhibitorDirectoryImage {...exhibitorImageProps} />
            <h4 className={Classes.exhibitorName} >{exhibitor.name}</h4>
            <div className={Classes.standName}>
              {exhibitor.standReference &&
                exhibitor.standReference.trim().length > 0 && !hideStandInfo &&
                <Stand standReference={exhibitor.standReference} translations={translation.directory} />}
            </div>
          </div>
        </a>
      </Col>
    );
  };

  render() {
    return (<Row className={Classes.exhibitorGridViewRow}>{this.generateExhibitors()} </Row>);
  }
}

ExhibitorDirectoryGridView.propTypes = {
  exhibitors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    logo: PropTypes.string,
    organisationGuid: PropTypes.string.isRequired,
    standReference: PropTypes.string
  })),
  context: PropTypes.shape({
    interfaceLocale: PropTypes.string.isRequired
  }).isRequired,
  navigation: PropTypes.shape({ exhibitorPublicDetailsUrlFormat: PropTypes.string.isRequired }).isRequired,
  isRounded: PropTypes.bool,
  hideStandInfo: PropTypes.bool
};

export default ExhibitorDirectoryGridView;
